import BaseEligibilityShow from "../../common/controllers/BaseEligibilityShow";

export default class ExtranetEligibilityShow extends BaseEligibilityShow {

    onStudyModalShow(e){
        super.onStudyModalShow(e);
        let $button = $(e.relatedTarget);
        let has_api = $button.data('has-api');
        console.log(has_api);
    }
}